import {View} from "react-native";
import {useRouter} from "expo-router";
import ActionButton from "@/lib/components/ActionButton";
import {useChat} from "@/lib/components/ChatProvider";

export default function ChatHeader() {
    const router = useRouter();

    const {currentChat} = useChat();

    if (!currentChat) {
        return null;
    }

    return (
        <View style={{flexDirection: "row", gap: 6}}>
            {true && <ActionButton
                onPress={() => router.push(`/chat/${currentChat.chat.id}/preferences`)}
                height={34}
                border={false}
                icon={"notification"}
            />}
            {true && <ActionButton
                onPress={() => router.push(`/chat/${currentChat.chat.id}/edit`)}
                height={34}
                border={false}
                icon={"edit"}
            />}
        </View>
    )
}